import {AnyObject, Application} from 'src';

/**
 * app 启动
 * @param app
 * @param options
 * @returns
 */
export default function bootstrapApp(app: Application): Promise<any> {
  const result = (app as any).bootstrap();
  return Promise.resolve(result)
    .then(() => {})
    .catch((err: Error) => {
      throw err;
    });
}
